'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var HEADER_LAYOUT = exports.HEADER_LAYOUT = 'web_header';

var PANEL_NAMES = exports.PANEL_NAMES = {
  keyword: 'keyword',
  location: 'location'
};

var ITEM_TYPES = exports.ITEM_TYPES = {
  location: 'location',
  venue: 'venue',
  activity: 'activity',
  favorites: 'favorites',
  links: 'links'
};

var NUM_HISTORY_IN_PANEL = exports.NUM_HISTORY_IN_PANEL = 3;
var NUM_VENUES_IN_PANEL = exports.NUM_VENUES_IN_PANEL = 6;
var NUM_ACTIVITIES_IN_PANEL = exports.NUM_ACTIVITIES_IN_PANEL = 3;

var DEFAULT_GEOLOCATION = exports.DEFAULT_GEOLOCATION = {
  lat: 40.715,
  lon: -73.997,
  name: 'New York'
};